import React, { useState } from "react"
import PropTypes from "prop-types"
import ModalForm from "../../../../components/compounds/modalForm/ModalForm.compunds"
import {
  isNotEmpty,
  validateFieldValue,
  checkValidationsAndIfHaveErrors,
} from "../../../../utils/validations.utils"
import FormContainer from "../../../../components/layouts/containers/FormContainer.container"
import FieldContainer from "../../../../components/layouts/containers/FieldContainer.container"
import InputTextForm from "../../../../components/molecules/InputTextForm.molecule"
import SecondaryButton from "../../../../components/molecules/buttons/SecondaryButton.molecule"
import PrimaryButton from "../../../../components/molecules/buttons/PrimaryButton.molecule"
import { reviewPendingVacationRequest } from "../../../../services/vacation.service"
import useToast from "../../../../hooks/useToast.hook"
import {
  VACATIONS_REJECT_VACATION_REQUEST_SUCCESS,
  VACATIONS_SAVE_ERROR_MESSAGE,
} from "../../../../consts/modules/vacations.consts"
const ModalFormRejectVacationRequest = ({
  visible,
  setVisible,
  setParentVisible,
  vacationRequest,
  triggerRefresh,
}) => {
  const initialDataState = {
    cancelationMotive: "",
  }
  const initialFieldsState = {
    cancelationMotive: {
      value: "",
      errors: [],
      typeValidations: [isNotEmpty],
      validationsOptions: {},
    },
  }
  const [submitting, setSubmitting] = useState(false)
  const [data, setData] = useState(initialDataState)
  const [validations, setValidations] = useState(initialFieldsState)
  const { setSuccessMessage, setErrorMessage } = useToast()
  const handleChange = ({ target: { name, value } }) => {
    setData((prev) => ({
      ...prev,
      [name]: value,
    }))
    setValidations(validateFieldValue(validations, name, value))
  }
  const handleSubmit = async () => {
    setSubmitting(true)
    try {
      const response = await reviewPendingVacationRequest(
        vacationRequest.idVacations,
        vacationRequest.vacationRangeId,
        false,
        data.cancelationMotive
      )
      if (!response.success) {
        throw new Error(response.message)
      }
      setVisible(false)
      resetFormState()
      setParentVisible && setParentVisible(false)
      triggerRefresh()
      setSuccessMessage(VACATIONS_REJECT_VACATION_REQUEST_SUCCESS)
    } catch (error) {
      setErrorMessage(VACATIONS_SAVE_ERROR_MESSAGE)
    } finally {
      setSubmitting(false)
    }
  }
  const resetFormState = () => {
    setData(initialDataState)
    setValidations(initialFieldsState)
  }
  const modalFooterTemplate = () => {
    return (
      <div>
        <SecondaryButton
          rounded
          label="Volver"
          onClick={() => {
            setVisible(false)
            resetFormState()
            setParentVisible && setParentVisible(true)
          }}
          disabled={submitting}
        />
        <PrimaryButton
          rounded
          icon={`pi ${submitting ? "pi-spin pi-spinner" : "pi-check"}`}
          label="Aceptar"
          onClick={handleSubmit}
          disabled={submitting || checkValidationsAndIfHaveErrors(validations)}
        />
      </div>
    )
  }
  return (
    <ModalForm
      visible={visible}
      setVisible={setVisible}
      headerTitle="Rechazar solicitud"
      headerIcon={
        <i className="pi pi-exclamation-triangle text-4xl clr-danger" />
      }
      footer={modalFooterTemplate()}
      cleanUp={resetFormState}
    >
      <div className="flex flex-column gap-3">
        <span>
          El integrante verá su solicitud rechazada, por favor agrega el motivo
          para explicarle la razón:
        </span>
        <FormContainer>
          <FieldContainer className="flex flex-column w-full m-0">
            <InputTextForm
              name="cancelationMotive"
              value={data.cancelationMotive}
              label="Motivo del rechazo"
              onChange={(e) => {
                handleChange(e)
              }}
              onBlur={() => {
                handleChange({
                  target: {
                    name: "cancelationMotive",
                    value: data.cancelationMotive?.trim(),
                  },
                })
              }}
              validations={validations.cancelationMotive}
              error={validations.cancelationMotive.errors}
              autoFocus
            />
          </FieldContainer>
        </FormContainer>
      </div>
    </ModalForm>
  )
}

export default ModalFormRejectVacationRequest

ModalFormRejectVacationRequest.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  setParentVisible: PropTypes.func,
  vacationRequest: PropTypes.object.isRequired,
  triggerRefresh: PropTypes.func,
}
